// En un archivo de utils/format.ts
export const formatCLP = (amount) => {
    return amount.toLocaleString('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
};

export const safeFormatCLP = (amount) => {
    if (!amount && amount !== 0) return '-';
    return formatCLP(amount);
};

export const formatNumberCL = (number) => {
    return number.toLocaleString('es-CL');
};


export const formatDate = (dateString) => {
    if (!dateString) return '--';

    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};


export const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
};


export function isLastCompleteWeekOfMonth(date = new Date()) {
    const year = date.getFullYear();
    const month = date.getMonth();

    // Obtener el último día del mes
    const lastDayOfMonth = new Date(year, month + 1, 0);
    const lastDay = lastDayOfMonth.getDate();
    const lastDayOfWeek = lastDayOfMonth.getDay();

    // Calcular el último viernes del mes
    let lastFriday;
    if (lastDayOfWeek >= 5) {
        // Si el último día es viernes (5) o después
        lastFriday = lastDay - (lastDayOfWeek - 5);
    } else {
        // Si el último día es antes del viernes, el último viernes es la semana anterior
        lastFriday = lastDay - (lastDayOfWeek + 2);
    }

    // El último lunes es 4 días antes del último viernes
    const lastMonday = lastFriday - 4;

    const currentDay = date.getDate();
    return currentDay >= lastMonday && currentDay <= lastFriday;
}